








































/* General */

/* Mixins */
import SearchableDropdownMixin from '@/mixins/searchable-dropdown.mixin'

/* Helpers */
import AssigneeAssistant from '@/helpers/assignee-assistant'

/* Types */
import { IPersonWithEmail } from '@/api/types/response.types'

export default SearchableDropdownMixin.extend({
  name: 'AssignmentPicker',

  props: {
    options: {
      type: Array as () => IPersonWithEmail[],
      default: (): IPersonWithEmail[] => [],
    },
    hideName: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'small',
    },
    /* Used for Jobs, but abstracting name to make this more abstract-y */
    title: {
      type: String,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      avatarSize: 19,
    }
  },

  computed: {
    totalOptionsCount(): number {
      return this.options.length
    },
    filteredOptions(): IPersonWithEmail[] {
      const result = AssigneeAssistant.getFullAssigneeOptions(
        this.options,
        this.$permissions,
      )

      if (this.filterQuery.length === 0) {
        return result
      }

      return result.filter(person => {
        return person.name
          .toLowerCase()
          .includes(this.filterQuery.toLowerCase())
      })
    },
    /* Null, if unassigned */
    selectedPerson(): IPersonWithEmail {
      return this.options.find(p => p.id === this.internalSelectedID)
    },
    loggedInPerson(): IPersonWithEmail {
      return this.options.find(p => this.$permissions.isLoggedInUser(p.id))
    },
    dropdownTitle(): string {
      return this.title ? this.title : 'People'
    },
    modifiers(): Array<String> {
      const selectors = [this.size]

      if (this.isDisabled) {
        selectors.push('disabled')
      }
      return selectors
    },
  },

  methods: {
    getName(person: IPersonWithEmail) {
      return person ? person.name : 'Unassigned'
    },
  },
})
